import { useState } from 'react';

export function useCadernoNavigation(activeWorkspace) {
  const [activePecaDoc, setActivePecaDoc] = useState(null);
  const [activeViewDoc, setActiveViewDoc] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(() => {
    return String(activeWorkspace?.clientId || activeWorkspace?.clientName || '').trim();
  });
  const [selectedClientName, setSelectedClientName] = useState(() => {
    return String(activeWorkspace?.clientName || activeWorkspace?.clientNameSnapshot || '').trim();
  });
  const extractClientMeta = (src) => {
    const cpf = String(src?.cpf || src?.clientCpf || src?.client?.cpf || '').trim();
    const cnpj = String(src?.cnpj || src?.clientCnpj || src?.client?.cnpj || '').trim();
    const email = String(src?.email || src?.clientEmail || src?.client?.email || src?.mail || '').trim();
    return { cpf, cnpj, email };
  };
  const [selectedClientMeta, setSelectedClientMeta] = useState(() => extractClientMeta(activeWorkspace));
  const [isClientPickerOpen, setIsClientPickerOpen] = useState(false);

  return {
    activePecaDoc, setActivePecaDoc,
    activeViewDoc, setActiveViewDoc,
    selectedClientId, setSelectedClientId,
    selectedClientName, setSelectedClientName,
    selectedClientMeta, setSelectedClientMeta,
    isClientPickerOpen, setIsClientPickerOpen,
  };
}
